import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/gestionTiempos/changeTimePattern";
import timePattern from "../../models/gestionTiempos/timePattern/timePattern";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    date: null,
    pattern: [],
    new: {},
    timePattern: [],
    deleteItem: [],
    editItems: [],
  },
  mutations: {
    setDate(state, data) {
      state.date = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setTimePattern(state, data) {
      state.timePattern = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setEditItems(state, data) {
      state.editItems = data;
    },
  },
  actions: {
    async newTimePattern(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(() => {
            let items = state.state.new;

            let options = state.state.pattern;
            let newItem = timePattern.fromJson({
              fecDedse: items.from,
              fecHasta: items.to,
              liqHoras: items.liqHoras,
              tarde: items.tarde,
              retAnt: items.retAnt,
              licPar: items.licPar,
              licTot: items.licTot,
              caidas: items.caidas,
              hCaiTol: items.tolerance,
              hCaiCsCostoId: items.cost,
              autorizLiq: items.autoriz,
            });
            options.push(newItem);

            state.commit("setTimePattern", items);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async getTimePattern(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getTimePattern();

          state.commit("setTimePattern", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            const deleteitem = state.state.deleteItem;

            state.commit("setDeleteItem", deleteitem);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.editItems).then(() => {
            const editItems = state.state.editItems;

            state.commit("setEditItems", editItems);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
